// extracted by mini-css-extract-plugin
module.exports = {"cvParseStatus":"styles_cvParseStatus__2Ann9","loading":"styles_loading__7h7oM","success":"styles_success__1zMTN","error":"styles_error__1-2Tb"};